import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { ExecutionInputType, ExecutionSaveResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useSaveExecutionMutation = (
  cb: (err: boolean, msg?: string) => void
) => {
  return useMutation<
    ExecutionSaveResponse,
    AxiosError<any>,
    {
      inputText?: string;
      inputType: ExecutionInputType;
      files?: File[];
      isConfidential: boolean;
      isTable: boolean;
    }
  >(
    ({ inputText, inputType, files, isConfidential, isTable }) => {
      const body = new FormData();
      body.append("inputType", inputType);
      if (inputText) {
        body.append("inputText", inputText);
      }
      body.append("isConfidential", isConfidential.toString());
      body.append("isTable", isTable.toString());
      if (files) {
        files.forEach((file) => {
          body.append("files", file);
        });
      }
      return axiosClient
        .post<ExecutionSaveResponse>(`/execution/save`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 10 * 60 * 1000, // 10 mins timeout
        })
        .then(({ data }) => data);
    },
    {
      onError: ({ response }) => {
        cb(true, "Something went wrong.");
      },
      onSuccess: () => {
        cb(false);
      },
      retry: false,
    }
  );
};
